<div class="busy-panel" *ngIf="isLoading">
  <div class="busy-panel-wrapper">
    <kendo-loader type="infinite-spinner"
                  themeColor="primary"
                  size="large">
    </kendo-loader>
    <div class="busy-panel-text">{{loadingMessage}}</div>
  </div>
</div>
